import { connect } from "react-redux";

import { showNotification } from "../../../../store/notification/actions";

import lazyComponent from "./lazy";

export default connect(null, { showNotification })(lazyComponent);
